import { useLanguage } from '../contexts/LanguageContext';
import { translations, Language } from '../i18n/translations';

export function useTranslation() {
  const { language } = useLanguage();
  
  const t = (key: string): any => {
    const keys = key.split('.');
    let value: any = translations[language as Language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value ?? key;
  };
  
  return { t, language };
}
